var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.596,
    height: 23.62,
    viewBox: "0 0 24.596 23.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirm",
    transform: "translate(-96.652 -94.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M108.462,117.968a11.81,11.81,0,1,1,7.882-20.605.656.656,0,0,1-.877.977,10.5,10.5,0,1,0,3.484,8.223.656.656,0,1,1,1.311.049,11.768,11.768,0,0,1-11.8,11.355Z",
    transform: "translate(0 0)",
    fill: "#f85f14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M255.642,264.186l-1.856-1.856-9.988,9.988-6.96-6.96-1.856,1.856,8.815,8.815h0Z",
    transform: "translate(-134.394 -163.201)",
    fill: "#f85f14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.4e2d0e2da85b3e4323e74fbef064e6de.svg";
export { ForwardRef as ReactComponent };